import { PaginationV2Links } from '@pickleballinc/react-ui';

interface BlogPaginationProps {
	currentPage: string;
	categorySlug: string;
	totalPages: number;
}

const BlogPagination = ({ currentPage, totalPages, categorySlug }: BlogPaginationProps) => {
	const page = currentPage === 'all' ? 0 : parseInt(currentPage);

	return (
		<>
			<div className="mb-4 mt-8 size-px w-full bg-gray-200 sm:mt-4" />
			<PaginationV2Links
				totalNumberOfPages={totalPages}
				currentPage={page}
				previousLink={`/${categorySlug}/${page - 1}`}
				nextLink={`/${categorySlug}/${page + 1}`}
				getPageLink={(page) => `/${categorySlug}/${page}`}
			/>
		</>
	);
};

export default BlogPagination;
